import { ParagraphAsLabel, WrapLgMarginBottom } from "App/global-style";
import { useTexts } from "Components/TextContext";
import { FormikProps } from "formik";
import React from "react";
import { BurglarAlarmSwitch } from "../../FormComponentsHouseProducts/SafetyMeasureQuestions/BurglarAlarmSwitch";
import { FireAlarmSwitch } from "../../FormComponentsHouseProducts/SafetyMeasureQuestions/FireAlarmSwitch";
import { HouseContentsProductPriceFormValues } from "../houseContentsFormValuesInterfaces";

interface Props {
  formProps: FormikProps<HouseContentsProductPriceFormValues>;
  recalculatePrice: (formProps: HouseContentsProductPriceFormValues) => void;
}

export const SafetyMeasureHouseContentsQuestions = ({
  ...props
}: Props): React.ReactElement => {
  const { getText } = useTexts();
  return (
    <WrapLgMarginBottom>
      <ParagraphAsLabel id="safetyMeasureLabel">
        {getText("housecontentsform.label.securitymeasures")}
      </ParagraphAsLabel>
      <div role="group" aria-labelledby="safetyMeasureLabel">
        <BurglarAlarmSwitch {...props} />
        <FireAlarmSwitch {...props} />
      </div>
    </WrapLgMarginBottom>
  );
};
